import { FunctionComponent } from 'react'
import { Dropdown } from 'react-bootstrap'

import Icon from 'components/ui/icon'
import { PendingTab } from './transferReport'
import transfersCss from '../styles.module.scss'

export const PENDING_OPTIONS: { value: PendingTab; label: string }[] = [
  { value: 'particular', label: 'Particular' },
  { value: 'convenios', label: 'Convênios' },
]

type MoreMenuProps = {
  /** E.g. "Baixar repasses pagos". */
  downloadLabel: string
  onDownload: () => void
  /** Particular vs. convênios; only for pending titles in the detail view. */
  pending?: { value: PendingTab; onChange: (value: PendingTab) => void }
}

/** Phones and tablets: the report actions behind a "more" (three dots) button. */
const MoreMenu: FunctionComponent<MoreMenuProps> = ({
  downloadLabel,
  onDownload,
  pending,
}) => (
  <Dropdown align="end" className="d-lg-none">
    <Dropdown.Toggle
      as="button"
      type="button"
      className="btn btn-ghost btn-icon dropdown-toggle-no-caret"
      aria-label="Mais opções"
      title="Mais opções"
    >
      <Icon name="more" size={18} />
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {pending && (
        <>
          <Dropdown.Header>Tipo de atendimento</Dropdown.Header>
          {PENDING_OPTIONS.map((option) => (
            <Dropdown.Item
              key={option.value}
              as="button"
              type="button"
              active={pending.value === option.value}
              onClick={() => pending.onChange(option.value)}
            >
              <span className={transfersCss.menuCheck}>
                {pending.value === option.value && <Icon name="check" size={14} />}
              </span>
              {option.label}
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
        </>
      )}
      <Dropdown.Item as="button" type="button" onClick={onDownload}>
        <Icon name="download" />
        {downloadLabel}
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
)

export default MoreMenu
